<template>
    <div>
        <label class="form-label fs-6 fw-bolder  text-dark"
               :class="item.is_required ? 'required' : ''">
            <slot v-if="i18n.locale.value == 'ar'">
                {{item.label_ar}}
            </slot>
            <slot v-if="i18n.locale.value == 'en'">
                {{item.label}}
            </slot>
            <slot v-if="!item.is_required">&nbsp;{{$t('optional')}}</slot>
        </label>

        <div class="fv-plugins-message-container">
            <div class="fv-help-block">
                <slot v-if="i18n.locale.value == 'ar'">
                    <span class="text-dark">{{item.hint_text_ar}}</span>
                </slot>
                <slot v-if="i18n.locale.value == 'en'">
                    <span class="text-dark">{{item.hint_text_en}}</span>
                </slot>
            </div>
        </div>
        <div class="fv-plugins-message-container">
            <div class="fv-help-block">
                <ErrorMessage :name="item.model_key + item.key"/>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
  import { defineComponent, ref, reactive, toRefs, inject, computed, onMounted } from 'vue';
  import { useStore } from 'vuex';
  import { useRouter, useRoute } from 'vue-router';
  import { useI18n } from 'vue-i18n';
  import { ErrorMessage, Field, Form } from 'vee-validate';


  export default defineComponent({
    name: 'FormLabel',
    components: {
      Field,
      ErrorMessage,
    },
    props: {
      item: Object,
    },
    setup(props, context) {
      const helpers: any = inject('helpers');
      const i18n = useI18n();

      let currentItem: any = props.item;
      // currentItem.key = Math.random().toString(16);
      const state = reactive({
        item: currentItem,
      });


      onMounted(() => {


      });


      return {
        ...toRefs(state),
        i18n,
        helpers,
      };
    },
  });
</script>